import {BaseError} from '../../../../../../../shared/errors/BaseError'
import {UIMMatchmakingController} from './matchmaking_selection/UIMMatchmakingController'
import {ViewPopup} from '../../../../../../shared/scripts/ui_popup/ViewPopup'

export class UIMHomepageController {
    private errorPopup: ViewPopup

    readonly matchmakingController: UIMMatchmakingController

    constructor() {
        this.matchmakingController = new UIMMatchmakingController()
    }

    onHomepageHide() {
        this.matchmakingController.removeSearchingScreen()
    }

    showMatchmakingError(error: BaseError) {
        this.matchmakingController.stopSearching()
        this.errorPopup?.removePopup()
        this.errorPopup = new ViewPopup({key: 'strings:popups.errors.matchmakingError.rankedMode'},
            error.description,
            () => undefined,
            () => undefined,
            true, {
                showXButton: false,
                showXonHeader: true,
            })
        this.errorPopup.show()
    }
}
